import React from "react";
import fs0 from "../../assets/images/fastingstreek/fs-0.png";
import fs1 from "../../assets/images/fastingstreek/fs-1.png";
import fs2 from "../../assets/images/fastingstreek/fs-2.png";
import NoFoodImage from "../../assets/images/dasboard/no-food.png";
import BasketImage from "../../assets/images/dasboard/basket.png";
import WeightImage from "../../assets/images/dasboard/weight.png";
import { daysOfWeek } from "../../function/functions";

const StreakSection = ({ fastingStreek, time, dashboardData, initialTime }) => {
  const windowType = dashboardData?.fastingtrack?.type;
  const activeWindowType = dashboardData?.fastingtrack?.activeWindow;
  const weekdays = daysOfWeek;

  const formatTimeUnit = (unit) => {
    return unit < 10 ? `0${unit}` : unit?.toString();
  };
  // console.log(currentDay);

  return (
    <>
      <div className="lg:w-1/2 md:w-3/4 sm:w-3/4 w-full mx-auto">
        {time !== "time" ? (
          <div className="text-center">
            <button className="border border-slate-200 text-capitalize rounded text-xs text-gray-200 !mb-7 p-2 sm:mt-2">
              {windowType === "start"
                ? activeWindowType + " in progress"
                : activeWindowType + " is paused"}
            </button>
            <div className="!mb-7 text-[48px] font-normal">
              {`${formatTimeUnit(time.hours)}:${formatTimeUnit(
                time.minutes
              )}:${formatTimeUnit(time.seconds)}`}
            </div>
          </div>
        ) : (
          <></>
        )}

        <div className={`${fastingStreek ? "dfdes mb-10" : "hidden"}`}>
          <div className="dfdes1">
            <img
              loading="lazy"
              src={NoFoodImage}
              alt="no-food"
              className="sm:w-12 w-8"
            />
            <div className="tabroe text-left">
              <div className="tabets sm:text-base text-xs font-medium leading-none">
                Fasting
              </div>
              <div className="tabetsbol">
                {initialTime?.fasting_hours + "h"}
              </div>
            </div>
          </div>
          <div className="dfdes1">
            <img
              loading="lazy"
              src={BasketImage}
              alt="basket"
              className="sm:w-12 w-8"
            />
            <div className="tabroe text-left">
              <div className="tabets sm:text-base text-xs font-medium leading-none">
                Eating
              </div>
              <div className="tabetsbol">{initialTime?.eating_hours + "h"}</div>
            </div>
          </div>
          <div className="dfdes1">
            <img
              loading="lazy"
              src={WeightImage}
              alt="weight"
              className="sm:w-12 w-8"
            />
            <div className="tabroe text-left">
              <div className="tabets sm:text-base text-xs font-medium leading-none">
                Weight Goal
              </div>
              <div className="tabetsbol">
                {dashboardData?.weightSummary?.targetWeight +
                  " " +
                  dashboardData?.weightSummary?.weightType}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className={`${
          fastingStreek
            ? "fastiweekbox lg:w-5/12 md:w-7/12 sm:w-2/3 w-full mx-auto mb-10"
            : "hidden"
        }`}
      >
        <div className="fastiweekboxtit text-sm font-semibold">
          Your fasting streak
        </div>
        <div className="fasweekdes mb-5">
          {fastingStreek &&
            weekdays?.map((row, index) => (
              <div className="tabroe" key={index}>
                <img
                  loading="lazy"
                  src={
                    fastingStreek[row] == 100
                      ? fs2
                      : fastingStreek[row] > 0 && fastingStreek[row] < 100
                      ? fs1
                      : fs0
                  }
                  alt="fireac"
                  className="w-6"
                />
                <div className="fastiweekboxtext text-xs mt-1 font-medium text-capitalize">
                  {row?.slice(0, 3)}
                </div>
              </div>
            ))}
        </div>
        <div className="text-xs font-medium text-center">
          <span className="">You’re </span>
          <span className="text-[#fe7701]">
            {" "}
            {fastingStreek?.tuesday}% more likely
          </span>
          <span className=""> to achieve your goal</span>
        </div>
      </div>
    </>
  );
};

export default React.memo(StreakSection);
